import {Component, Inject, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from '../../store/store.index';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {IncidentsActions} from '../../store/incidents/incidents.index';

@Component({
  selector: 'ps-create-comment',
  templateUrl: 'create.comment.component.html'
})
export class CreateCommentComponent implements OnInit {

  comment: string;

  constructor(private store: Store<ProleisSuppliersState>, private bottomSheetRef: MatBottomSheetRef,
              @Inject(MAT_BOTTOM_SHEET_DATA) private data: any) {
  }

  ngOnInit(): void {
  }

  createComment() {
    this.store.dispatch(IncidentsActions.ADD_COMMENT({
      incidentId: this.data,
      comment: this.comment
    }));
    this.bottomSheetRef.dismiss({
      comment: this.comment
    });
  }

  dismiss() {
    this.bottomSheetRef.dismiss();
  }

}
